// export class TextAnalyticsConfig {    
//     domainOption: string;
//     aoAnalytics : AoAnalytics;
//     ioAnalytics: IoAnalytics;
//     othersAnalytics: OthersAnalytics;    
//     constructor() {        
//     }
// }
export class AoAnalytics {
    mappingConfigFilter: string;
    mappingConfigData: string;
    deepdiveConfig: string;
    selectedAlgorithm: number;
    noOfCluster: number;
    exitCriteria: number;
    applicationName: string;
    classifiedBasedON: string;
    categorisedBy: string;
    ticketType: string;
    startDate: string;
    endDate: string;
    ignoreKeywords: { Language: string, Keywords: string[]}[];
    actualOpportunityBy: string;
    actualclassifiedBasedON: string;
    Language: string;
    enableDQT: boolean;
  IsLemmaEnabled: boolean;
}
export class IoAnalytics {
    mappingConfigFilter: string;
    mappingConfigData: string;
    deepdiveConfig: string;
    selectedAlgorithm: number;
    noOfCluster: number;
    exitCriteria: number;
    classifiedBasedON: string;
    categorisedBy: string;
    ticketType: string;
    applicationName: string;
    startDate: string;
    endDate: string;
    ignoreKeywords: { Language: string, Keywords: string[]}[];
    actualOpportunityBy: string;
    actualclassifiedBasedON: string;
    Language: string;
    enableDQT: boolean;
  IsLemmaEnabled: boolean;
}
export class OthersAnalytics {
    mappingConfigFilter: string;
    mappingConfigData: string;
    deepdiveConfig: string;
    selectedAlgorithm: number;
    noOfCluster: number;
    exitCriteria: number;
    classifiedBasedON: string;
    categorisedBy: string;
    ticketType: string;
    applicationName: string;
    startDate: string;
    endDate: string;
    ignoreKeywords: { Language: string, Keywords: string[]}[];
    actualOpportunityBy: string;
    actualclassifiedBasedON: string;
    Language: string;
    enableDQT: boolean;
  IsLemmaEnabled: boolean;
}
export class ScopeTree {
    deliveryConstruct: string;
    deliveryConstructUId: string;
    deliveryConstructType: string;
    parentDeliveryConstructType: string;
    parentDeliveryConstructUId: string;
    status: string;
    closureDate: string;
    workstreamTypeID: any;
}

export class StandardAnalytics {
    UserOption : string
    deepdiveConfig: string;
    ticketType: string;
    startDate: string;
    endDate: string;
    ClassifiedBased: string;
}
